import { render, staticRenderFns } from "./AirportFaq.vue?vue&type=template&id=685b4b23"
import script from "./AirportFaq.vue?vue&type=script&lang=js"
export * from "./AirportFaq.vue?vue&type=script&lang=js"
import style0 from "./AirportFaq.vue?vue&type=style&index=0&id=685b4b23&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports